import React from "react";
import {Route, Switch} from "react-router-dom";
import BuddyProfile from "../BuddyProfile/BuddyProfile";
import Buddies from "../Buddies/Buddies";

export default function BuddiesRoutes() {
    return (
        <Switch>
            <Route
                path="/buddies/profile/:id"
                render={({match}) => <BuddyProfile mentorId={match.params.id} />}
            />
            <Route path="/buddies" render={() => <Buddies />} />
        </Switch>
    );
}
